import {
  SET_TABLE_CHIP_FILTER,
  RESET_TABLE_CHIP_FILTERS,
} from "../actions/actionTypes"

const defaultFiltersPerTable = {
  scheduling: {
    facilityName: null,
    specialty: [],
    practitionerType: [],
    faclityState: [],
    provider: [],
    shiftType: [],
    bookingStatus: [],
  },
  shifts: {
    bookingStatus: [],
    shiftType: [],
    specialty: [],
    practitionerType: [],
  },
  timesheet: { approvalStatus: [], specialty: [] },
  spendTimesheet: { approvalStatus: [], specialty: [], practitionerType: [] },
  spendInvoices: { status: [], specialty: [], practitionerType: [] },
  dashboardIframe: { facility: [], specialty: [], dateRange: null },
}

const INITIAL_STATE = Object.freeze({ ...defaultFiltersPerTable })

export const tableFiltersReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_TABLE_CHIP_FILTER: {
      const { tableKey, filterKey, values } = action.payload
      return {
        ...state,
        [tableKey]: { ...state[tableKey], [filterKey]: values },
      }
    }
    case RESET_TABLE_CHIP_FILTERS:
      return {
        ...state,
        [action.payload.tableKey]: {
          ...defaultFiltersPerTable[action.payload.tableKey],
        },
      }
    default:
      return state
  }
}

export default tableFiltersReducer
